/* eslint-disable */
import React, { useEffect, useState } from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// react components for routing our app without refresh
import { Link, useNavigate } from "react-router-dom";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Icon from "@material-ui/core/Icon";
import classNames from "classnames";
// @material-ui/icons
import Apps from "@material-ui/icons/Apps";
import ShoppingCart from "@material-ui/icons/ShoppingCart";
import ViewDay from "@material-ui/icons/ViewDay";
import Dns from "@material-ui/icons/Dns";
import Build from "@material-ui/icons/Build";
import ListIcon from "@material-ui/icons/List";
import People from "@material-ui/icons/People";
import Person from "@material-ui/icons/Person";
import Logout from "@material-ui/icons/ExitToApp";
import Assignment from "@material-ui/icons/Assignment";
import MonetizationOn from "@material-ui/icons/MonetizationOn";
import Chat from "@material-ui/icons/Chat";
import Call from "@material-ui/icons/Call";
import ViewCarousel from "@material-ui/icons/ViewCarousel";
import AccountBalance from "@material-ui/icons/AccountBalance";
import ArtTrack from "@material-ui/icons/ArtTrack";
import ViewQuilt from "@material-ui/icons/ViewQuilt";
import LocationOn from "@material-ui/icons/LocationOn";
import Fingerprint from "@material-ui/icons/Fingerprint";
import AttachMoney from "@material-ui/icons/AttachMoney";
import Store from "@material-ui/icons/Store";
import AccountCircle from "@material-ui/icons/AccountCircle";
import PersonAdd from "@material-ui/icons/PersonAdd";
import Layers from "@material-ui/icons/Layers";
import ShoppingBasket from "@material-ui/icons/ShoppingBasket";
import LineStyle from "@material-ui/icons/LineStyle";
import Error from "@material-ui/icons/Error";
import { Repeat } from "@material-ui/icons";

// core components
import CustomDropdown from "components/CustomDropdown/CustomDropdown.js";
import Button from "components/CustomButtons/Button.js";
import customerDetailsStyles from "assets/jss/material-kit-pro-react/views/cspDashboard/customerDetailsStyles.js";
import styles from "assets/jss/material-kit-pro-react/components/headerLinksStyle.js";
import { useDispatch, useSelector } from "react-redux";
import { logoutUser } from "../../redux/ducks/userSlice";
import { resetInternal } from "../../redux/ducks/manageInternal";
import CustomerListDialog from "views/CSPDashboardPage/Sections/Component/CustomerListDialog";
import { resetDashboard } from "../../redux/ducks/CSPDashboardSlice";

const useStyles = makeStyles(styles);
const useStylesCustomerDetailsStyles = makeStyles(customerDetailsStyles);

export default function HeaderLinks(props) {
	const classesCSStyles = useStylesCustomerDetailsStyles();
	const userInfo = useSelector((state) => state.user);
	const manageInternal = useSelector((state) => state.manageInternal);
	const [dialogToggle, setDialogToggle] = useState(false);
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const currentUrl = window.location.href;
	const currentUrlParams = new URL(currentUrl);
	const pathName = currentUrlParams?.pathname;
	useEffect(() => {}, [userInfo]);

	const easeInOutQuad = (t, b, c, d) => {
		t /= d / 2;
		if (t < 1) return (c / 2) * t * t + b;
		t--;
		return (-c / 2) * (t * (t - 2) - 1) + b;
	};

	const smoothScroll = (e, target) => {
		if (window.location.pathname === "/sections") {
			var isMobile = navigator.userAgent.match(
				/(iPad)|(iPhone)|(iPod)|(android)|(webOS)/i
			);
			if (isMobile) {
				// if we are on mobile device the scroll into view will be managed by the browser
			} else {
				e.preventDefault();
				var targetScroll = document.getElementById(target);
				scrollGo(document.documentElement, targetScroll.offsetTop, 1250);
			}
		}
	};
	const scrollGo = (element, to, duration) => {
		var start = element.scrollTop,
			change = to - start,
			currentTime = 0,
			increment = 20;

		var animateScroll = function () {
			currentTime += increment;
			var val = easeInOutQuad(currentTime, start, change, duration);
			element.scrollTop = val;
			if (currentTime < duration) {
				setTimeout(animateScroll, increment);
			}
		};
		animateScroll();
	};

	const { dropdownHoverColor } = props;
	const classes = useStyles();

	const logOut = () => {
		dispatch(logoutUser());
		dispatch(resetInternal());
		dispatch(resetDashboard());

		localStorage.clear();
		navigate("/login");
	};
	const handleLogin = () => {
		navigate("/login");
	};
	const handleLogOut = () => {
		dispatch(resetInternal());

		localStorage.clear();
		window.location.href = "/";
	};

	return (
		<>
			{userInfo && (
				<div className={classNames(classesCSStyles.userWelcomeSection)}>
					<h4 className={classes.labelLogin}>
						Welcome {userInfo?.name}
						<br />
						{userInfo?.company_name}
					</h4>
				</div>
			)}
			<List className={classes.list + " " + classes.mlAuto}>
				{/* <ListItem className={classes.listItem}>
					<CustomDropdown
						noLiPadding
						navDropdown
						hoverColor={dropdownHoverColor}
						buttonText="Components"
						buttonProps={{
							className: classes.navLink,
							color: "transparent",
						}}
						buttonIcon={Apps}
						dropdownList={[
							<Link to="/" className={classes.dropdownLink}>
								<LineStyle className={classes.dropdownIcons} /> Presentation Page
							</Link>,
							<Link to="/components" className={classes.dropdownLink}>
								<Layers className={classes.dropdownIcons} />
								All components
							</Link>,
							<a
								href="https://demos.creative-tim.com/material-kit-pro-react/#/documentation/tutorial?ref=mkpr-navbar"
								target="_blank"
								className={classes.dropdownLink}>
								<Icon className={classes.dropdownIcons}>content_paste</Icon>
								Documentation
							</a>,
						]}
					/>
				</ListItem>
				<ListItem className={classes.listItem}>
					<CustomDropdown
						noLiPadding
						navDropdown
						hoverColor={dropdownHoverColor}
						buttonText="Sections"
						buttonProps={{
							className: classes.navLink,
							color: "transparent",
						}}
						buttonIcon={ViewDay}
						dropdownList={[
							<Link
								to="/sections#headers"
								className={classes.dropdownLink}
								onClick={(e) => smoothScroll(e, "headers")}>
								<Dns className={classes.dropdownIcons} /> Headers
							</Link>,
							<Link
								to="/sections#features"
								className={classes.dropdownLink}
								onClick={(e) => smoothScroll(e, "features")}>
								<Build className={classes.dropdownIcons} /> Features
							</Link>,
							<Link
								to="/sections#blogs"
								className={classes.dropdownLink}
								onClick={(e) => smoothScroll(e, "blogs")}>
								<ListIcon className={classes.dropdownIcons} /> Blogs
							</Link>,
							<Link
								to="/sections#teams"
								className={classes.dropdownLink}
								onClick={(e) => smoothScroll(e, "teams")}>
								<People className={classes.dropdownIcons} /> Teams
							</Link>,
							<Link
								to="/sections#projects"
								className={classes.dropdownLink}
								onClick={(e) => smoothScroll(e, "projects")}>
								<Assignment className={classes.dropdownIcons} /> Projects
							</Link>,
							<Link
								to="/sections#pricing"
								className={classes.dropdownLink}
								onClick={(e) => smoothScroll(e, "pricing")}>
								<MonetizationOn className={classes.dropdownIcons} /> Pricing
							</Link>,
							<Link
								to="/sections#testimonials"
								className={classes.dropdownLink}
								onClick={(e) => smoothScroll(e, "testimonials")}>
								<Chat className={classes.dropdownIcons} /> Testimonials
							</Link>,
							<Link
								to="/sections#contacts"
								className={classes.dropdownLink}
								onClick={(e) => smoothScroll(e, "contacts")}>
								<Call className={classes.dropdownIcons} /> Contacts
							</Link>,
						]}
					/>
				</ListItem> */}

				{userInfo && (
					<ListItem className={classes.listItem}>
						<CustomDropdown
							noLiPadding
							navDropdown
							hoverColor={dropdownHoverColor}
							buttonText={
								<div className="flex ">
									<div className={classes.profileImageContainer}>
										<img
											src={
												userInfo?.salepersonphoto
													? userInfo?.salepersonphoto
													: "https://placehold.co/50x50"
											}
											onError={(e) => {
												e.target.onerror = null; // prevents looping
												e.target.src = "https://placehold.co/50x50";
											}}
											alt="profile"
											className={classes.profileImage}
										/>
									</div>
									<div>
										<div className={classes.labelLogin}>{userInfo?.salename}</div>
										<div className={classes.labelLogin}>Phone: {userInfo?.salephone}</div>
									</div>
								</div>
							}
							buttonProps={{
								className: classes.navLink,
								color: "transparent",
							}}
							dropdownList={[
								<Link
									to="/users"
									className={classes.dropdownLink}
									onClick={() => {
										navigate("/users");
									}}>
									<AccountCircle className={classes.dropdownIcons} /> Users
								</Link>,
								<div className={classes.dropdownLink} onClick={logOut}>
									<Logout className={classes.dropdownIcons} /> Log out
								</div>,
							]}
						/>
					</ListItem>
				)}
				{userInfo && (
					<ListItem className={classNames(classes.listItem, classesCSStyles?.mxr10)}>
						<div className={classes.labelLogin}>Support 1300 504 101</div>
						<div className={classes.emailLogin}>cloudsupport@auscomp.au</div>
					</ListItem>
				)}
				{!userInfo &&
					(!manageInternal || manageInternal?.token == "") &&
					pathName != "/login" && (
						<ListItem className={classes.listItem}>
							<button className={classesCSStyles.headerPrimary} onClick={handleLogin}>
								Login
							</button>
						</ListItem>
					)}

				{manageInternal?.token != "" && (
					<ListItem className={classes.listItem}>
						<button
							className={classesCSStyles.headerPrimary}
							onClick={() => setDialogToggle(true)}>
							<Repeat className={classesCSStyles?.buttonIcon} />
						</button>
						<button className={classesCSStyles.headerPrimary} onClick={handleLogOut}>
							<Logout className={classesCSStyles?.buttonIcon} />
						</button>
					</ListItem>
				)}
			</List>
			{dialogToggle && manageInternal?.token && (
				<CustomerListDialog
					loginToken={
						manageInternal.token ? manageInternal.token : userDetails?.token
					}
					dialogToggle={dialogToggle}
					setDialogToggle={setDialogToggle}
				/>
			)}
		</>
	);
}

HeaderLinks.defaultProps = {
	hoverColor: "primary",
};

HeaderLinks.propTypes = {
	dropdownHoverColor: PropTypes.oneOf([
		"dark",
		"primary",
		"info",
		"success",
		"warning",
		"danger",
		"rose",
	]),
};
